import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  const mobileCheck = () => {
    return window.innerWidth <= 768;
  };

  // Shorter versions for mobile
  const mobileStrings = [
    "BESC LLC: Premier construction & home improvement specialists.",
    "Revolutionizing the industry with crypto and CEX integration.",
    "Where innovation meets craftsmanship."
  ];

  // Full versions for desktop
  const desktopStrings = [
    "Builders Edge Services & Construction (BESC LLC) is a premier construction and home improvement company specializing in residential and commercial projects.",
    "With the launch of our crypto coin and the Builders Exchange (CEX) platform, we're revolutionizing the industry. Enjoy seamless payments, rewards, and transparency, all while trading on our secure, user-friendly exchange.",
    "BESC is where innovation and craftsmanship come together."
  ];

  return (
    <>
      <div className="type-container" style={{ 
        fontSize: mobileCheck() ? "1.4rem" : "1.6rem",
        lineHeight: "1.6",
        textAlign: "left",
        maxWidth: "100%",
        overflow: "hidden",
        fontWeight: "500",
        marginBottom: "2rem"
      }}>
        <Typewriter
          options={{
            strings: mobileCheck() ? mobileStrings : desktopStrings,
            autoStart: true,
            loop: true,
            deleteSpeed: 50,
            delay: 50,
            pauseFor: 3000,
            wrapperClassName: "typewriter-wrapper",
            cursorClassName: "typewriter-cursor"
          }}
        />
      </div>
      
      <div className="contract-card" style={{
        background: "rgba(255, 255, 255, 0.05)",
        padding: "1.5rem",
        borderRadius: "15px",
        backdropFilter: "blur(10px)",
        border: "1px solid rgba(255, 255, 255, 0.1)",
        maxWidth: "100%",
        overflow: "hidden",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
      }}>
        <h3 style={{ 
          margin: "0 0 1rem 0",
          fontSize: "1.2rem",
          color: "rgba(255, 255, 255, 0.9)"
        }}>
          Contract Address
        </h3>
        <div style={{
          background: "rgba(0, 0, 0, 0.3)",
          padding: "1rem",
          borderRadius: "10px",
          wordBreak: "break-all",
          fontFamily: "monospace",
          fontSize: "0.9rem",
          letterSpacing: "0.5px",
          color: "rgba(255, 255, 255, 0.8)"
        }}>
          DDE8MnEjYsukfiG2DCu4EeJM3wU4jngLci65mQyzYs7H {/* Ganti dengan alamat kontrak yang sebenarnya */}
        </div>
      </div>
    </>
  );
}

export default Type;
